import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { withDefaults } from '@warp-drive/legacy/model/migration-support';

export const LtiResourceLinkSchema = withDefaults({
  type: DataTypeLti.ResourceLink,
  legacy: true,
  identity: {
    kind: '@id',
    name: 'id',
  },
  fields: [
    { kind: 'attribute', name: 'consumedToolDeploymentId', type: 'string' },
    { kind: 'attribute', name: 'platformResourceLinkId', type: 'string' },
    { kind: 'attribute', name: 'toolItemType', type: 'string' },
    { kind: 'attribute', name: 'toolItemId', type: 'string' },
    { kind: 'attribute', name: 'isActive', type: 'boolean' },
    { kind: 'attribute', name: 'platformId', type: 'string' },
    { kind: 'attribute', name: 'consumedToolId', type: 'string' },
    { kind: 'attribute', name: 'platformDeploymentId', type: 'string' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'consumedToolDeployment',
      type: DataTypeLti.ConsumedToolDeployment,
      options: {
        async: true,
        inverse: 'resourceLinks',
      },
    },
  ],
});
